<template>
  <div class="app-container content-information">
    <div class="navigation new-demo">
      <el-button size="mini" type="primary-icon-medium" icon="icon-ccui-return" @click="handleBack">返回</el-button>
      <div class="cut-line"/>
      <!-- 面包屑 -->
      <el-breadcrumb class="crumbs-container" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">模板应用</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tmpl/demo/demo-list' }">功能模块</el-breadcrumb-item>
        <el-breadcrumb-item><span>新增</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="info-form">
      <el-card-title :title="title"/>
      <div class="form-content">
        <el-form :model="form" :rules="rules" ref="form"  label-width="100px">
          <el-form-item label="名称：" prop="demoName">
            <el-input v-model="form.demoName" class="input-long" placeholder="请输入名称"/>
          </el-form-item>
          <el-form-item label="用户名：" prop="userName">
            <el-input v-model="form.userName" class="input-long" placeholder="请输入用户名"/>
          </el-form-item>
          <el-form-item label="年龄：">
            <el-input v-model="form.age" class="input-long" placeholder="请输入年龄"/>
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="form.phone" class="input-long" placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item label="单价：">
            <el-input v-model="form.skuPrince" class="input-long" placeholder="请输入单价"/>
          </el-form-item>
          <el-form-item label="库存量：">
            <el-select v-model="form.skuNum" class="input-long" placeholder="请选择库存量" value="">
              <el-option label="10" value="10"></el-option>
              <el-option label="20" value="20"></el-option>
              <el-option label="30" value="30"></el-option>
              <el-option label="40" value="40"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              v-model="form.createDate"
              type="date"
              placeholder="选择日期"/>
          </el-form-item>
          <el-form-item label="修改时间：">
            <el-date-picker
              v-model="form.modifyDate"
              type="date"
              placeholder="选择日期"/>
          </el-form-item>
          <el-form-item label="创建人ID：">
            <el-input v-model="form.createUserId" class="input-long" placeholder="请输入创建人ID"/>
          </el-form-item>
          <el-form-item label="创建人：">
            <el-input v-model="form.createUser" class="input-long" placeholder="请输入创建人"/>
          </el-form-item>
          <el-form-item label="修改人ID：">
            <el-input v-model="form.modifyUserId" class="input-long" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="修改人：">
            <el-input
              type="textarea"
              autosize
              class="input-long"
              placeholder="请输入内容"
              v-model="form.modifyUser">
            </el-input>
          </el-form-item>
          <el-form-item label="是否启用：">
            <el-radio v-model="form.status" label="0">禁用</el-radio>
            <el-radio v-model="form.status" label="1">启用</el-radio>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bottom-guide detail-bottom">
      <ul class="bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack">返回</el-button>
        </li>
        <div class="bottom-center-solid"/>
        <li>
          <el-button type="bottom" icon="icon-ccui-save-submit" @click="submitHandle('form')">保存</el-button>
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="resetHandle">取消</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { addDemo } from '@/api/new-demo'

export default {
  name: 'NewContract',
  data () {
    var validateMobilePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('负责人手机号不可为空'))
      } else {
        if (value !== '') {
          var reg = /^1[3456789]\d{9}$/
          if (!reg.test(value)) {
            callback(new Error('请输入有效的手机号码'))
          }
        }
        callback()
      }
    }
    return {
      title: '新增信息',
      form: {
        state: '1',
        demoName: '',
        userName: '',
        age: '',
        phone: '',
        skuPrince: '',
        skuNum: '',
        createDate: '',
        modifyDate: '',
        createUserId: '',
        createUser: '',
        modifyUserId: '',
        modifyUser: ''
      },
      rules: {
        demoName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输用户名', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validateMobilePhone, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  created () {
  },
  activated () {
    console.log('路由活跃状态')
  },
  methods: {
    // 清空输入框
    resetHandle () {
      console.log('重置编辑信息')
      this.form = {}
    },
    submitHandle (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDemo()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addDemo () {
      const obj = {
        demoName: this.form.demoName,
        userName: this.form.userName,
        age: this.form.age,
        phone: this.form.phone,
        skuPrince: this.form.skuPrince,
        skuNum: this.form.skuNum,
        status: this.form.status,
        modifyDate: this.form.modifyDate,
        modifyUserId: this.form.modifyUserId,
        modifyUser: this.form.modifyUser,
        isShowLoading: true
      }
      addDemo(obj).then(res => {
        console.log(res)
        this.$message({
          message: '新增成功',
          type: 'success',
          // duration: 3000,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        })
        this.form = {}
        this.$router.push({ path: '/tmpl/demo/demo-list' })
      }).catch(e => {
        console.log(e)
      })

    },
    // 返回
    handleBack () {
      this.$router.push({ path: '/tmpl/demo/demo-list' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/variables";
  .new-supplier {
  }
</style>
